import React from 'react'
import {
  Tooltip as MUITooltip,
  TooltipProps as MUITooltipProps
} from '@mui/material'

import useStyles from './styles'

interface TooltipProps extends MUITooltipProps {
  subtext?: React.ReactNode
  disabled?: boolean
  enableInteractive?: boolean
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  subtext,
  disabled,
  children,
  enableInteractive = false,
  ...props
}) => {
  const classes = useStyles()

  if (!title || disabled) {
    return children
  }

  return (
    <MUITooltip
      title={
        <div className={classes.root}>
          {title}
          {subtext && <div>{subtext}</div>}
        </div>
      }
      disableInteractive={!enableInteractive}
      {...props}
    >
      {children}
    </MUITooltip>
  )
}

export default Tooltip
